import { QueryClient } from '@tanstack/react-query';
import { resetAllUserDataAtoms } from './atom-registry';
import type { WritableAtom } from 'jotai';

interface JotaiStore {
  set: <Value, Args extends unknown[], Result>(
    atom: WritableAtom<Value, Args, Result>,
    ...args: Args
  ) => Result;
}

export function clearAllUserData(queryClient: QueryClient, jotaiStore: JotaiStore) {
  try {
    // Clear React Query cache completely
    queryClient.clear();
    
    // Reset all registered user data atoms
    resetAllUserDataAtoms(jotaiStore);
    
  } catch (error) {
    console.error('  ** Error clearing user data:', error);
    // Don't throw - ensure cleanup continues even if partial failure
  }
}